var login_popup = ( function( $ ) {

	var _init = function() {
		_setup_popup();

		$( '.login-popup-link' ).on( 'click', _click_event );
	};

	var _click_event = function( e ) {
		var $form = $( '#login-popup' ).find( 'form[name="loginform"]' );
		var $input = $form.find( 'input[name="redirect_to"]' );

		var redirect = $( this ).data( 'redirect' );
		redirect = redirect ? redirect : $input.data( 'original' );

		$input.val( redirect );
	};

	var _setup_popup = function() {
		$( '.login-popup-link' ).magnificPopup( {
		type : 'inline',
		removalDelay: 300,
		mainClass: 'login-popup-in',
		preloader : false,
		focus : '#login-popup-focus',
		callbacks : {
			beforeOpen : function() {
				if( $( window ).width() < 700 ) {
					this.st.focus = false;
				} else {
					this.st.focus = '#name';}
				}
			}
	   } );
	};

	if ( $( '.login-popup-link' ).length > 0 ) {
		_init();
	}

	return {};

} )( jQuery );

module.exports = login_popup;